module.exports = __webpack_public_path__ + "img/logo7.7e4f5dbf.png";